import { useLocation, useNavigate } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path: string;
}

export function Breadcrumb() {
  const location = useLocation();
  const navigate = useNavigate();

  const getBreadcrumbs = (): BreadcrumbItem[] => {
    const pathSegments = location.pathname.split('/').filter(Boolean);
    const breadcrumbs: BreadcrumbItem[] = [
      { label: 'Dashboard', path: '/' }
    ];

    // Handle different routes
    if (pathSegments.length === 0) {
      return [{ label: 'Dashboard', path: '/' }];
    }

    const routeMap: Record<string, string> = {
      'inquiries': 'Inquiries',
      'cases': 'Cases',
      'clients': 'Clients',
      'call-logs': 'Call Logs',
      'calendar': 'Calendar',
      'messages': 'Messages',
      'tasks': 'Tasks',
      'documents': 'Documents',
      'task-templates': 'Task Templates'
    };

    pathSegments.forEach((segment, index) => {
      const path = '/' + pathSegments.slice(0, index + 1).join('/');
      
      if (routeMap[segment]) {
        breadcrumbs.push({
          label: routeMap[segment],
          path: path
        });
      } else if (segment.match(/^[0-9a-f-]+$/)) {
        // Handle ID segments (like case/client IDs)
        const parentSegment = pathSegments[index - 1];
        if (parentSegment === 'cases') {
          breadcrumbs.push({
            label: `Case #${segment.slice(0, 8)}`,
            path: path
          });
        } else if (parentSegment === 'clients') {
          breadcrumbs.push({
            label: `Client Details`,
            path: path
          });
        } else if (parentSegment === 'inquiries') {
          breadcrumbs.push({
            label: `Inquiry Details`,
            path: path
          });
        }
      }
    });

    return breadcrumbs;
  };

  const breadcrumbs = getBreadcrumbs();

  if (breadcrumbs.length <= 1) {
    return null;
  }

  return (
    <nav className="flex items-center space-x-1 text-sm text-gray-600 mb-4">
      {breadcrumbs.map((crumb, index) => (
        <div key={crumb.path} className="flex items-center">
          {index > 0 && (
            <svg className="w-4 h-4 mx-2 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          )}
          {index === breadcrumbs.length - 1 ? (
            <span className="font-medium text-gray-900">{crumb.label}</span>
          ) : (
            <button
              onClick={() => navigate(crumb.path)}
              className="hover:text-aalaw-red transition-colors font-medium"
            >
              {crumb.label}
            </button>
          )}
        </div>
      ))}
    </nav>
  );
}